<script setup>
  import InstanceBillingCard from "./InstanceBillingCard.vue";
  import InterfaceBillingCard from "./InterfaceBillingCard.vue";
  import VolumeBillingCard from "./VolumeBillingCard.vue";
  import { computed } from "vue";

  const props = defineProps({
    data: {
      type: Object,
      default: null,
    },
  });
  const instanceBilling = computed(() => props.data.IaasAssetBilling);
  const interfaceBilling = computed(() =>
    props.data.Interfaces.map((ob) => ob.IaasAssetBilling).flat()
  );
  const volumeBilling = computed(() =>
    props.data.Volumes.map((volume) => ({
      ...volume,
      billing: volume.IaasAssetBilling,
    }))
  );
</script>
<template>
  <div class="container mx-auto gap-3" dir="ltr">
    <InstanceBillingCard
      :instanceBilling="instanceBilling"
      class="my-3 py-3 box"
    />
    <InterfaceBillingCard
      :interface-data="data.Interfaces"
      class="my-3 py-3 box"
    />
    <VolumeBillingCard :volume-data="data.Volumes" class="my-3 py-3 box" />
  </div>
</template>

<style scoped>
  /* You can add custom styles if necessary */
</style>
